import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
import useLocalStorage from "../../hooks/useLocalStorage";

export type Props = {
  text: string;
  learnMore: string;
  close: string;
};

export default function CookieBannerComponent({
  close,
  text,
  learnMore,
}: Props) {
  const [hasConsented, setConsented] = useLocalStorage("cookie-consent", 0);
  if (hasConsented === 1) return null;
  return (
    <div className="bg-primary-100">
      <div className="mx-auto flex max-w-7xl items-start justify-center py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center p-2">
          <p className="ml-3 text-gray-600">{text}</p>
          <a
            href="/privacy"
            target="_blank"
            rel="noreferrer"
            style={{ userSelect: "none" }}
            className="ml-3 text-primary-600 hover:text-primary-800"
          >
            {learnMore}
          </a>
        </div>
        <button
          type="button"
          className="-mr-1 ml-2 flex rounded-md p-2 text-gray-600 hover:bg-indigo-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:-mr-2"
          onClick={() => setConsented(1)}
        >
          <span className="sr-only">{close}</span>
          <XMarkIcon className="h-6 w-6 " aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
